"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var baseWallet_1 = __importDefault(require("./baseWallet"));

var ExtensionWallet = function (_super) {
  __extends(ExtensionWallet, _super);

  function ExtensionWallet() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ExtensionWallet.prototype.type = function () {
    return ExtensionWallet.TYPE;
  };

  ExtensionWallet.prototype.id = function () {
    return ExtensionWallet.TYPE;
  };

  ExtensionWallet.prototype.loadNetworkId = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!this.isSupported()) {
            reject(baseWallet_1.default.NotSupportedError);
          }

          window.web3.version.getNetwork(function (err, networkId) {
            if (err) {
              reject(err);
            } else {
              resolve(networkId);
            }
          });
          return [2];
        });
      });
    });
  };

  ExtensionWallet.prototype.signMessage = function (message) {
    return this.signPersonalMessage(message);
  };

  ExtensionWallet.prototype.signPersonalMessage = function (message) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!this.isSupported()) {
            reject(baseWallet_1.default.NotSupportedError);
          }

          window.web3.personal.sign(window.web3.toHex(message), window.web3.eth.accounts[0], function (err, res) {
            if (err) {
              reject(err);
            } else {
              resolve(res);
            }
          });
          return [2];
        });
      });
    });
  };

  ExtensionWallet.prototype.sendTransaction = function (txParams) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!this.isSupported()) {
            reject(baseWallet_1.default.NotSupportedError);
          }

          window.web3.eth.sendTransaction(txParams, function (err, res) {
            if (err) {
              reject(err);
            } else {
              resolve(res);
            }
          });
          return [2];
        });
      });
    });
  };

  ExtensionWallet.prototype.sendCustomRequest = function (method, params) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!this.isSupported()) {
            reject(baseWallet_1.default.NotSupportedError);
          }

          window.web3.currentProvider.sendAsync({
            method: method,
            params: params,
            from: window.web3.eth.accounts[0]
          }, function (err, res) {
            if (err) {
              reject(err);
            } else {
              resolve(res);
            }
          });
          return [2];
        });
      });
    });
  };

  ExtensionWallet.prototype.getAddresses = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (!this.isSupported()) {
            reject(baseWallet_1.default.NotSupportedError);
          }

          window.web3.eth.getAccounts(function (err, accounts) {
            if (err) {
              reject(err);
            } else {
              resolve(accounts);
            }
          });
          return [2];
        });
      });
    });
  };

  ExtensionWallet.enableBrowserExtensionWallet = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!window.ethereum) {
              return [2];
            }

            return [4, window.ethereum.enable()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ExtensionWallet.prototype.isLocked = function (address) {
    return !address;
  };

  ExtensionWallet.prototype.isSupported = function () {
    return !!window.web3;
  };

  ExtensionWallet.prototype.name = function () {
    if (!this.isSupported()) {
      return "";
    }

    var cp = window.web3.currentProvider;

    if (cp.isMetaMask) {
      return "MetaMask";
    } else if (cp.isCipher) {
      return "Cipher";
    } else if (cp.isTrust) {
      return "Trust";
    } else if (cp.isToshi) {
      return "Coinbase";
    } else {
      return "Extension Wallet";
    }
  };

  ExtensionWallet.LABEL = "Extension Wallet";
  ExtensionWallet.TYPE = "EXTENSION";
  return ExtensionWallet;
}(baseWallet_1.default);

exports.default = ExtensionWallet;